import React from "react";

import { Button } from "shared/ui";

import { useModifierSetsContext } from "features/ModifierSets/context";
import { modifierSetSummary } from "features/ModifierSets/lib/modifierSetSummary";
import { localizedText } from "shared/lib/localizedMap";

import { Actions, Info, List, Meta, Name, Row } from "./styles";

export const ModifierSetsList = () => {
    const state = useModifierSetsContext();

    return (
        <List>
            {state.modifierSets.map((modifierSet) => (
                <Row key={modifierSet.id} onClick={() => state.openEditDialog(modifierSet)}>
                    <Info>
                        <Name>{localizedText(modifierSet.name, state.locale)}</Name>
                        <Meta>{modifierSetSummary(modifierSet)}</Meta>
                    </Info>
                    <Actions onClick={(event: React.MouseEvent) => event.stopPropagation()}>
                        <Button
                            variant="outlined"
                            color="danger"
                            onClick={() => state.openDeleteDialog(modifierSet)}
                        >
                            Удалить
                        </Button>
                    </Actions>
                </Row>
            ))}
        </List>
    );
};
